import React, { useState } from 'react'
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import PageHeader from '../../components/PageHeader'
import General from './General'
// import Billing from './Billing'
// import Members from './Members'
import Security from './Security'
import Notifiactions from './Notifiactions'

const Account = () => {
  const [activeTab, setActiveTab] = useState('general');
  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader title='Account' />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <PageHeader title="Account" />
              <div className="row align-items-center">
                <div className="col">

                  <ul className="nav nav-tabs nav-overflow header-tabs">
                    <li className="nav-item">
                      <button className={`nav-link ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}>General</button>
                    </li>
                    {/* <li className="nav-item">
                      <button className={`nav-link ${activeTab === 'billing' ? 'active' : ''}`} onClick={() => setActiveTab('billing')}>Billing</button>
                    </li>
                    <li className="nav-item">
                      <button className={`nav-link ${activeTab === 'members' ? 'active' : ''}`} onClick={() => setActiveTab('members')}>Members</button>
                    </li> */}
                    <li className="nav-item">
                      <button className={`nav-link ${activeTab === 'security' ? 'active' : ''}`} onClick={() => setActiveTab('security')}>Security</button>
                    </li>
                    <li className="nav-item">
                      <button className={`nav-link ${activeTab === 'notifications' ? 'active' : ''}`} onClick={() => setActiveTab('notifications')}>Notifications</button>
                    </li>
                  </ul>
                  <div className="mt-4">
                    {activeTab === 'general' && <General />}
                    {/* {activeTab === 'billing' && <Billing />}
                    {activeTab === 'members' && <Members />} */}
                    {activeTab === 'security' && <Security />}
                    {activeTab === 'notifications' && <Notifiactions />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Account